var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "validated-form-group",
                {
                  attrs: {
                    "validation-errors": _vm.validationErrors,
                    "validation-id": "MPZip"
                  }
                },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-md": "12",
                        "label-cols-lg": "12"
                      }
                    },
                    [
                      _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("Postinumero")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c("postal-autocomplete", {
                            attrs: {
                              id: "mp_postalStr_field",
                              "street-locale": _vm.mpStreetLocale,
                              "post-office-target": "#mp-address-place"
                            },
                            on: {
                              "postal-code-selected":
                                _vm.meteringPointPostalSelected
                            },
                            model: {
                              value: _vm.postalStr,
                              callback: function($$v) {
                                _vm.postalStr = $$v
                              },
                              expression: "postalStr"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-4" },
          [
            _c(
              "validated-form-group",
              {
                attrs: {
                  "validation-id": "MPStreet",
                  "validation-errors": _vm.validationErrors
                }
              },
              [
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-10",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-md": "12",
                      "label-cols-lg": "12"
                    }
                  },
                  [
                    _c("label", { staticClass: "font-weight-bold pt-0" }, [
                      _vm._v(_vm._s(_vm.$t("Käyttöpaikan osoite")))
                    ]),
                    _vm._v(" "),
                    _c("street-autocomplete", {
                      attrs: {
                        id: "mp_mpStreetStr_field",
                        "postal-filter": _vm.contract.MeteringPoint.Address.Zip,
                        "zip-locale": _vm.mpZipLocale
                      },
                      on: {
                        "street-selected": _vm.meteringPointStreetSelected
                      },
                      model: {
                        value: _vm.mpStreetStr,
                        callback: function($$v) {
                          _vm.mpStreetStr = $$v
                        },
                        expression: "mpStreetStr"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-3" }, [
          _c(
            "div",
            {
              staticClass: "form-group metering-point-info",
              attrs: { "data-validation-id": "MPZip" }
            },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-md": "12",
                    "label-cols-lg": "12"
                  }
                },
                [
                  _vm.contract.MeteringPoint.Address.Zip
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("Postinumero")))
                      ])
                    : _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("")))
                      ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "form-control-static vertical",
                    attrs: { name: "MPZip" },
                    domProps: {
                      textContent: _vm._s(
                        _vm.contract.MeteringPoint.Address.Zip
                      )
                    }
                  })
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-3" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-md": "12",
                    "label-cols-lg": "12"
                  }
                },
                [
                  _vm.contract.MeteringPoint.Address.Place
                    ? _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("Postitoimipaikka")))
                      ])
                    : _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("")))
                      ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "form-control-static vertical",
                    domProps: {
                      textContent: _vm._s(
                        _vm.contract.MeteringPoint.Address.Place
                      )
                    }
                  })
                ]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          staticClass: "row"
        },
        [
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6 col-md-4" },
            [
              _c(
                "validated-form-group",
                {
                  attrs: {
                    "validation-id": "COName",
                    "validation-errors": _vm.validationErrors
                  }
                },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-md": "12",
                        "label-cols-lg": "12"
                      }
                    },
                    [
                      _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("c/o Nimi")))
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        directives: [
                          {
                            name: "new-contract-value",
                            rawName: "v-new-contract-value"
                          }
                        ],
                        attrs: {
                          type: "text",
                          name: "MPCOName",
                          maxlength: "70",
                          value: _vm.contract.MeteringPoint.Address.COName
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-6 col-sm-6 col-md-4 col-lg-3" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    "label-cols-sm": "12",
                    "label-cols-md": "12",
                    "label-cols-lg": "12"
                  }
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "font-weight-bold pt-0",
                      attrs: { for: "mp-code" }
                    },
                    [_vm._v(_vm._s(_vm.$t("Käyttöpaikkatunnus")))]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.gsrnCode,
                        expression: "gsrnCode"
                      },
                      {
                        name: "new-contract-value",
                        rawName: "v-new-contract-value"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "gsrn-code",
                      name: "GsrnCode",
                      maxlength: "18",
                      disabled: _vm.disableMeteringPointcodeField
                    },
                    domProps: { value: _vm.gsrnCode },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.gsrnCode = $event.target.value
                      }
                    }
                  })
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.contract.MeteringPoint.NetworkCompanyName != null
          ? _c("div", { staticClass: "col-xs-6 col-sm-6 col-md-4 col-lg-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-md": "12",
                        "label-cols-lg": "12"
                      }
                    },
                    [
                      _c("label", { staticClass: "font-weight-bold pt-0" }, [
                        _vm._v(_vm._s(_vm.$t("")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-md": "12",
                        "label-cols-lg": "12",
                        "label-align-md": "right"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.contract.MeteringPoint.NetworkCompanyName)
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.contract.MeteringPoint.SearchedNotFound
        ? _c("div", { staticClass: "row ml-2" }, [
            _c(
              "div",
              { staticClass: "col-xs-24 col-sm-24 col-md-24 col-lg-24" },
              [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mb-0",
                        attrs: {
                          "label-cols-sm": "24",
                          "label-cols-md": "24",
                          "label-cols-lg": "24"
                        }
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "font-weight-bold pt-0",
                            staticStyle: { color: "red" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Tarkistathan vielä antamasi käyttöpaikan osoitetiedot ja jatka sopimuksen tekoa painamalla jatka."
                                )
                              )
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isInvoicingMethodsInUse
        ? [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("b-col", { attrs: { md: "12" } }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "checkbox-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "new-contract-value",
                            rawName: "v-new-contract-value"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "IsInvoicingAddressInUse",
                          "true-value": "1",
                          "false-value": "0"
                        },
                        domProps: {
                          checked: _vm.contract.IsInvoicingAddressInUse
                        }
                      }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t(
                              "Haluan laskut sähköpostilla / Laskutusosoite on eri kuin käyttöpaikan osoite."
                            )
                          ) +
                          "\n                    "
                      )
                    ])
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("transition", { on: { "after-enter": _vm.afterEnter } }, [
              _vm.contract.IsInvoicingAddressInUse
                ? _c("div", { staticClass: "panel panel-default" }, [
                    _c("div", { staticClass: "panel-heading" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("Laskutustiedot")) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "panel-body" },
                      [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "Mikäli haluat vaihtaa oletuslaskutustietoja, voit vaihtaa niitä tässä."
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-xs-12 col-sm-12 col-md-12" },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: _vm.invoicingMethodELaskuStr,
                                      expression: "invoicingMethodELaskuStr"
                                    }
                                  ],
                                  staticClass: "form-group"
                                },
                                [
                                  _c(
                                    "validated-form-group",
                                    {
                                      staticClass: "no-margin-bottom",
                                      attrs: {
                                        "validation-id": "InvoicingMethod",
                                        "validation-errors":
                                          _vm.validationErrors
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-0",
                                          attrs: {
                                            "label-cols-sm": "12",
                                            "label-cols-md": "12",
                                            "label-cols-lg": "12"
                                          }
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "font-weight-bold pt-0"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Laskutustapa"))
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "label",
                                          { staticClass: "radio-inline" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "new-contract-value",
                                                  rawName:
                                                    "v-new-contract-value"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                name: "InvoicingMethod",
                                                disabled:
                                                  _vm.hasConsumerEInvoiceContract
                                              },
                                              domProps: {
                                                value:
                                                  _vm.InvoicingMethodEnum.Email,
                                                checked:
                                                  _vm.contract
                                                    .InvoicingMethod ==
                                                  _vm.InvoicingMethodEnum.Email
                                              },
                                              on: {
                                                "value-updated":
                                                  _vm.invoicingMethodChanged
                                              }
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("sähköpostilasku")
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.contract.CustomerType ==
                                        _vm.CustomerTypeEnum.CONSUMER
                                          ? _c(
                                              "label",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName: "v-b-tooltip",
                                                    value:
                                                      _vm.invoicingMethodELaskuStrDisabled,
                                                    expression:
                                                      "invoicingMethodELaskuStrDisabled"
                                                  }
                                                ],
                                                staticClass: "radio-inline"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name:
                                                        "new-contract-value",
                                                      rawName:
                                                        "v-new-contract-value"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "radio",
                                                    name: "InvoicingMethod",
                                                    disabled: !_vm.hasConsumerEInvoiceContract
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.InvoicingMethodEnum
                                                        .ConsumerEInvoice,
                                                    checked:
                                                      _vm.contract
                                                        .InvoicingMethod ==
                                                      _vm.InvoicingMethodEnum
                                                        .ConsumerEInvoice
                                                  },
                                                  on: {
                                                    "value-updated":
                                                      _vm.invoicingMethodChanged
                                                  }
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("e-lasku")) +
                                                    "\n                                        "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.contract.CustomerType ==
                                        _vm.CustomerTypeEnum.COMPANY
                                          ? _c(
                                              "label",
                                              { staticClass: "radio-inline" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name:
                                                        "new-contract-value",
                                                      rawName:
                                                        "v-new-contract-value"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "radio",
                                                    name: "InvoicingMethod"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.InvoicingMethodEnum
                                                        .CompanyEInvoice,
                                                    checked:
                                                      _vm.contract
                                                        .InvoicingMethod ==
                                                      _vm.InvoicingMethodEnum
                                                        .CompanyEInvoice
                                                  },
                                                  on: {
                                                    "value-updated":
                                                      _vm.invoicingMethodChanged
                                                  }
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("verkkolasku")
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _vm.contract.InvoicingMethod ==
                          _vm.InvoicingMethodEnum.Email
                            ? _c(
                                "div",
                                { staticClass: "col-xs-12 col-sm-12 col-md-5" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c(
                                        "validated-form-group",
                                        {
                                          attrs: {
                                            "validation-id": "DeliveryEmail",
                                            "validation-errors":
                                              _vm.validationErrors
                                          }
                                        },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-0",
                                              attrs: {
                                                "label-cols-sm": "12",
                                                "label-cols-md": "12",
                                                "label-cols-lg": "12"
                                              }
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "font-weight-bold pt-0",
                                                  attrs: {
                                                    for: "DeliveryEmail"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Laskutussähköposti"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.contract.DeliveryEmail,
                                                expression:
                                                  "contract.DeliveryEmail"
                                              },
                                              {
                                                name: "new-contract-value",
                                                rawName: "v-new-contract-value"
                                              }
                                            ],
                                            staticClass:
                                              "form-control contract-field",
                                            attrs: {
                                              type: "email",
                                              id: "DeliveryEmail",
                                              name: "DeliveryEmail",
                                              maxlength: "100"
                                            },
                                            domProps: {
                                              value: _vm.contract.DeliveryEmail
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.contract,
                                                  "DeliveryEmail",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.contract.InvoicingMethod ==
                        _vm.InvoicingMethodEnum.CompanyEInvoice
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { xs: "12", sm: "6", md: "5" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      [
                                        _c(
                                          "validated-form-group",
                                          {
                                            attrs: {
                                              "validation-id":
                                                "InvoicingNetworkAddress",
                                              "validation-errors":
                                                _vm.validationErrors
                                            }
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                staticClass: "mb-0",
                                                attrs: {
                                                  "label-cols-sm": "12",
                                                  "label-cols-md": "12",
                                                  "label-cols-lg": "12"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold pt-0",
                                                    attrs: {
                                                      for:
                                                        "invoicingNetworkAddress"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Verkkolaskuosoite (OVT-tunnus)"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.contract
                                                      .InvoicingAddress
                                                      .InvoicingNetworkAddress,
                                                  expression:
                                                    "contract.InvoicingAddress.InvoicingNetworkAddress"
                                                },
                                                {
                                                  name: "new-contract-value",
                                                  rawName:
                                                    "v-new-contract-value"
                                                }
                                              ],
                                              staticClass:
                                                "form-control contract-field",
                                              attrs: {
                                                type: "text",
                                                id: "invoicingNetworkAddress",
                                                name: "InvoicingNetworkAddress",
                                                maxlength: "50"
                                              },
                                              domProps: {
                                                value:
                                                  _vm.contract.InvoicingAddress
                                                    .InvoicingNetworkAddress
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.contract
                                                      .InvoicingAddress,
                                                    "InvoicingNetworkAddress",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      [
                                        _c(
                                          "validated-form-group",
                                          {
                                            attrs: {
                                              "validation-id":
                                                "InvoicingOperator",
                                              "validation-errors":
                                                _vm.validationErrors
                                            }
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                staticClass: "mb-0",
                                                attrs: {
                                                  "label-cols-sm": "12",
                                                  "label-cols-md": "12",
                                                  "label-cols-lg": "12"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold pt-0",
                                                    attrs: {
                                                      for: "invoicingOperator"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Välittäjätunnus"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.contract
                                                      .InvoicingAddress
                                                      .InvoicingOperator,
                                                  expression:
                                                    "contract.InvoicingAddress.InvoicingOperator"
                                                },
                                                {
                                                  name: "new-contract-value",
                                                  rawName:
                                                    "v-new-contract-value"
                                                }
                                              ],
                                              staticClass:
                                                "form-control contract-field",
                                              attrs: {
                                                type: "text",
                                                id: "invoicingOperator",
                                                name: "InvoicingOperator",
                                                maxlength: "50"
                                              },
                                              domProps: {
                                                value:
                                                  _vm.contract.InvoicingAddress
                                                    .InvoicingOperator
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.contract
                                                      .InvoicingAddress,
                                                    "InvoicingOperator",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _vm.contract.CustomerType ==
                          _vm.CustomerTypeEnum.COMPANY
                            ? _c(
                                "div",
                                { staticClass: "col-sm-12 col-md-4" },
                                [
                                  _c(
                                    "validated-form-group",
                                    {
                                      staticClass: "no-margin-bottom",
                                      attrs: {
                                        "validation-id": "InvoicingContactName",
                                        "validation-errors":
                                          _vm.validationErrors
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-0",
                                          attrs: {
                                            "label-cols-sm": "12",
                                            "label-cols-md": "12",
                                            "label-cols-lg": "12"
                                          }
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "font-weight-bold pt-0",
                                              attrs: {
                                                for: "invoicing-contact"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Yhteyshenkilö"))
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.contract.InvoicingAddress
                                                .ContactPersonName,
                                            expression:
                                              "contract.InvoicingAddress.ContactPersonName"
                                          },
                                          {
                                            name: "new-contract-value",
                                            rawName: "v-new-contract-value"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "invoicing-contact",
                                          type: "text",
                                          name: "InvoicingContactPersonCompany",
                                          maxlength: "70"
                                        },
                                        domProps: {
                                          value:
                                            _vm.contract.InvoicingAddress
                                              .ContactPersonName
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.contract.InvoicingAddress,
                                              "ContactPersonName",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-sm-12 col-md-5" },
                            [
                              _c(
                                "validated-form-group",
                                {
                                  staticClass: "no-margin-bottom",
                                  attrs: {
                                    "validation-id": "InvoicingStreet",
                                    "validation-errors": _vm.validationErrors
                                  }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-0",
                                      attrs: {
                                        "label-cols-sm": "12",
                                        "label-cols-md": "12",
                                        "label-cols-lg": "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "font-weight-bold pt-0",
                                          attrs: {
                                            for: "InvoicingStreetStr_field"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Laskutusosoite"))
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("street-autocomplete", {
                                    attrs: {
                                      id: "InvoicingStreetStr_field",
                                      "postal-filter":
                                        _vm.contract.InvoicingAddress.Address
                                          .Zip
                                    },
                                    on: {
                                      "street-selected":
                                        _vm.invoicingStreetSelected
                                    },
                                    model: {
                                      value: _vm.invoicingStreetStr,
                                      callback: function($$v) {
                                        _vm.invoicingStreetStr = $$v
                                      },
                                      expression: "invoicingStreetStr"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-xs-12 col-sm-12 col-md-3" },
                            [
                              _c(
                                "validated-form-group",
                                {
                                  staticClass: "no-margin-bottom",
                                  attrs: {
                                    "validation-id": "InvoicingZip",
                                    "validation-errors": _vm.validationErrors
                                  }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-0",
                                      attrs: {
                                        "label-cols-sm": "12",
                                        "label-cols-md": "12",
                                        "label-cols-lg": "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "font-weight-bold pt-0",
                                          attrs: { for: "InvoicingZip_field" }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Postinumero")))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("postal-autocomplete", {
                                    attrs: {
                                      id: "InvoicingZip_field",
                                      "post-office-target":
                                        "#invoicing-post-office"
                                    },
                                    on: {
                                      "postal-code-selected":
                                        _vm.invoicingPostalSelected
                                    },
                                    model: {
                                      value: _vm.invoicingZipStr,
                                      callback: function($$v) {
                                        _vm.invoicingZipStr = $$v
                                      },
                                      expression: "invoicingZipStr"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-xs-12 col-sm-12 col-md-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "form-group no-margin-bottom" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-0",
                                      attrs: {
                                        "label-cols-sm": "12",
                                        "label-cols-md": "12",
                                        "label-cols-lg": "12"
                                      }
                                    },
                                    [
                                      _vm.contract.InvoicingAddress.Address
                                        .Place
                                        ? _c(
                                            "label",
                                            {
                                              staticClass:
                                                "font-weight-bold pt-0",
                                              attrs: {
                                                for: "invoicing-post-office"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("Postitoimipaikka")
                                                )
                                              )
                                            ]
                                          )
                                        : _c(
                                            "label",
                                            {
                                              staticClass:
                                                "font-weight-bold pt-0",
                                              attrs: {
                                                for: "invoicing-post-office"
                                              }
                                            },
                                            [_vm._v(_vm._s(_vm.$t("")))]
                                          )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", {
                                    staticClass: "form-control-static vertical",
                                    attrs: { id: "invoicing-post-office" },
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.contract.InvoicingAddress.Address
                                          .Place
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { md: "12" } }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "b-form-group",
                  {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-md": "12",
                      "label-cols-lg": "12"
                    }
                  },
                  [
                    _c("label", { staticClass: "font-weight-bold pt-0" }, [
                      _vm._v(_vm._s(_vm.$t("Laskujen määrä vuodessa")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "validated-form-group",
                      {
                        attrs: {
                          "validation-id": "InvoicingGroup",
                          "validation-errors": _vm.validationErrors
                        }
                      },
                      [
                        _c("label", { staticClass: "radio-inline" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "new-contract-value",
                                rawName: "v-new-contract-value"
                              }
                            ],
                            attrs: { type: "radio", name: "InvoicingGroup" },
                            domProps: {
                              value: 4,
                              checked: _vm.contract.InvoicingGroup == 4
                            }
                          }),
                          _vm._v(
                            " 4 " +
                              _vm._s(_vm.$t("kpl")) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "radio-inline" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "new-contract-value",
                                rawName: "v-new-contract-value"
                              }
                            ],
                            attrs: { type: "radio", name: "InvoicingGroup" },
                            domProps: {
                              value: 6,
                              checked: _vm.contract.InvoicingGroup == 6
                            }
                          }),
                          _vm._v(
                            " 6 " +
                              _vm._s(_vm.$t("kpl")) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "radio-inline" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "new-contract-value",
                                rawName: "v-new-contract-value"
                              }
                            ],
                            attrs: { type: "radio", name: "InvoicingGroup" },
                            domProps: {
                              value: 12,
                              checked: _vm.contract.InvoicingGroup == 12
                            }
                          }),
                          _vm._v(
                            " 12 " +
                              _vm._s(_vm.$t("kpl")) +
                              "\n                        "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasMembership ? _c("div", [_c("Membership")], 1) : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "validated-form-group",
                {
                  attrs: {
                    "validation-id": "StartDate",
                    "validation-errors": _vm.validationErrors
                  }
                },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        "label-cols-sm": "12",
                        "label-cols-md": "12",
                        "label-cols-lg": "12"
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c(
                              "label",
                              {
                                staticClass: "font-weight-bold pt-0",
                                attrs: { for: "startdate-datepicker" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Sopimuksen toivottu alkamispäivämäärä"
                                    )
                                  )
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { xs: "12", sm: "12", md: "6", lg: "4" } },
                            [
                              _c("b-form-datepicker", {
                                directives: [
                                  {
                                    name: "new-contract-value",
                                    rawName: "v-new-contract-value"
                                  }
                                ],
                                staticClass: "mb-2",
                                attrs: {
                                  id: "startdate-datepicker",
                                  placeholder: "pp.kk.vvvv",
                                  "start-weekday": "1",
                                  name: "StartDate",
                                  "date-format-options": {
                                    day: "numeric",
                                    month: "numeric",
                                    year: "numeric"
                                  },
                                  locale: _vm.datePickerlanguage,
                                  "hide-header": true,
                                  "label-help": "",
                                  min: _vm.minDate,
                                  max: _vm.maxDate,
                                  "date-disabled-fn": _vm.disableDates,
                                  "no-highlight-today": ""
                                },
                                model: {
                                  value: _vm.startDate,
                                  callback: function($$v) {
                                    _vm.startDate = $$v
                                  },
                                  expression: "startDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "Huomioithan, että verkkoyhtiö voi ottaa sinuun yhteyttä kytkennän turvallisuuden varmistamiseksi."
                  )
                )
              )
            ])
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }